import { headers } from '../const/headers'
import { releaseConfirmationDefault } from '../domain/releaseConfirmation/releaseConfirmation'
import { snackbar } from '@/core/controller/snackbar_controller';

class ReleaseConfirmationController {
    context = null;
    headers = headers;
    loading = false;
    search = "";
    searchEquipment = "";
    searchCode = "";
    searchTruckDriver = "";
    dialog = false;
    statusSelected = 0
    form = releaseConfirmationDefault()
    statusList = [
    { text: "Todas", value: 0 },
    { text: "Pendentes", value: 1 }, 
    { text: "Confirmadas Todas", value: 2 },
    { text: "Confirmadas e senha gerada", value: 3 },
    { text: "Confirmadas e senha não gerada", value: 4 },
    { text: "Rejeitadas", value: 5 },
    ]
    releaseConfirmationPagination = {
        total: 0,
        items: []
    }
 
    options = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["createdDate"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: [true]
    }

    truckDriverPagination = {
        total: 0,
        items: []
    }
    
    truckDriverOptions = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["name"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    equipmentPagination = {
      total: 0,
      items: []
    }  
    
    equipmentOptions = {
      page: 1,
      itemsPerPage: 40,
      groupBy: [],
      sortBy: ["name"],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      sortDesc: []
    }

    constructor(
        context,
        fetchReleaseConfirmationUseCaseImpl,
        changeReleaseConfirmationUseCaseImpl,
        fetchTruckDriverUseCaseImpl,
        fetchEquipmentUseCaseImpl,
        fetchCodeUseCaseImpl

    ) {
        this.context = context,
        this.fetchReleaseConfirmationUseCaseImpl = fetchReleaseConfirmationUseCaseImpl,
        this.changeReleaseConfirmationUseCaseImpl = changeReleaseConfirmationUseCaseImpl,
        this.fetchTruckDriverUseCaseImpl = fetchTruckDriverUseCaseImpl,
        this.fetchEquipmentUseCaseImpl = fetchEquipmentUseCaseImpl
        this.fetchCodeUseCaseImpl = fetchCodeUseCaseImpl
    }

    async paginate() {
        this.loading = true
        try {
          this.releaseConfirmationPagination = await this.fetchReleaseConfirmationUseCaseImpl(this.options, this.search, this.statusSelected);
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false
        }
    }

    async truckDriverPaginate() {
        try {
            this.truckDriverPagination = await this.fetchTruckDriverUseCaseImpl(this.truckDriverOptions, this.searchTruckDriver)
        } catch (error) {
            console.log(error);
        } finally {
            this.loading = false
        }
    };

    async equipmentPaginate() {
        try {
        this.equipmentPagination = await this.fetchEquipmentUseCaseImpl(this.equipmentOptions, this.searchEquipment)
        } catch (error) {
        console.log(error);
        } finally {
        this.loading = false
        }
    }

    async codePaginate() {
        try {
            this.codePagination = await this.fetchCodeUseCaseImpl(this.codeOptions, this.searchCode)
        } catch (error) {
            console.log(error);
        } finally {
            this.loading = false
        }
    };

    async confirmRelease(item) {
        try {
            const confirm = await snackbar.confirm({ message: "Deseja realmente confirmar a solicitação?", color: "primary", timeout: 5000 })
            if (confirm) {
                this.loading = true
                await this.changeReleaseConfirmationUseCaseImpl(item.id, { ...item, 
                    allowed: true })
                snackbar.show({ message: "Solicitação confirmada com sucesso!", color: "#008000", timeout: 3000 })
            }
            this.paginate()
        } catch (error) {
            snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 3000 })
        } finally {
            this.loading = false
        }
    }

    async rejectRelease(item) {
        try {
            const confirm = await snackbar.confirm({ message: "Deseja realmente rejeitar a solicitação?", color: "primary", timeout: 5000 })
            if (confirm) {
                this.loading = true
                await this.changeReleaseConfirmationUseCaseImpl(item.id, { 
                    ...item, 
                    rejected: true
                })
                snackbar.show({ 
                    message: "Solicitação rejeitada com sucesso!", 
                    color: "primary", 
                    timeout: 3000 
                })
            }
            this.paginate()
        } catch (error) {
            snackbar.show({ 
                message: error.toString(), 
                color: "#ff0000", 
                timeout: 3000 
            })
        } finally {
            this.loading = false
        }
    }


    changeStatus() {
        this.paginate()
    }

    watchOptions() {
        this.paginate()
    }
    watchSearch() {
        this.paginate()
    }
    watchTruckDriverOptions() {
        this.truckDriverPaginate()
    }
    watchTruckDriverSearch() {
        this.truckDriverPaginate()
    }
    watchEquipmentOptions() {
        this.equipmentPaginate();
    }
    watchEquipmentSearch() {
        this.equipmentPaginate();
    }
    watchCodeOptions() {
        this.codePaginate()
    }
    watchCodeSearch() {
        this.codePaginate()
    }

}

export default ReleaseConfirmationController